export interface BidLimitedContactDTO {
  id: string;
  contactName: string;
  email: string;
}
